import "./EmployeeLogin.scss"
import React from 'react'
import EmployeeLoginForm from "./components/login-form/EmployeeLoginForm"

const EmployeeLogin = () => {
  return (
    <div className="EmployeeLogin flex justify-content-center align-items-center">
      <EmployeeLoginForm />
    </div>
  )
}

export default EmployeeLogin